import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'confirmation_modal.title',
        defaultMessage: 'Confirmation',
    },
    emailTitle: {
        id: 'confirmation_modal.email.title',
        defaultMessage: 'Enter code from email',
    },
    phoneTitle: {
        id: 'confirmation_modal.phone.title',
        defaultMessage: 'Enter code from phone',
    },
    emailText: {
        id: 'confirmation_modal.email.text',
        defaultMessage: 'The code should be delivered within a minute to',
    },
    phoneText: {
        id: 'confirmation_modal.phone.text',
        defaultMessage: 'The code should be delivered within a minute to',
    },
    emailLabel: {
        id: 'confirmation_modal.email.label',
        defaultMessage: 'Email code',
    },
    phoneLabel: {
        id: 'confirmation_modal.phone.label',
        defaultMessage: 'SMS code',
    },
    twoFaTitle: {
        id: 'confirmation_modal.two_fa.title',
        defaultMessage: 'Enter 2FA or backup code',
    },
    twoFaLabel: {
        id: 'confirmation_modal.two_fa.label',
        defaultMessage: '2FA or backup code',
    },
    paste: {
        id: 'confirmation_modal.paste',
        defaultMessage: 'Paste',
    },
    continue: {
        id: 'confirmation_modal.continue',
        defaultMessage: 'Continue',
    },
})
